<template>
  <b-row>
    <b-col>
      <vue-form-generator
      :schema="schema"
      :options="options"
      :model="model"
      ref="selectButtonForm"
      ></vue-form-generator>
    </b-col>
  </b-row>
</template>

<script>
import SCHEMA from './schema';

export default {
  props: {
    model: {
      type: Object,
      required: true,
    },
    attr: {
      type: String,
      required: true,
    },
    label: String,
    addLabel: {
      type: String,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    prefix: {
      type: String,
      default() { return 'select-button-form-'; },
    },
  },
  computed: {
    schema() {
      return SCHEMA.schema(this.label, this.attr, this.map, this.addLabel, this.addClicked);
    },
    options() {
      return SCHEMA.formOptions(this.prefix);
    },
  },
  methods: {
    addClicked() {
      if (this.model[this.attr]) {
        this.$emit('submit', this.model);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/selects/select_button_form/SelectButtonForm.vue